/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { APIOfferFileSearchResult } from './APIOfferFileSearchResult';
import {
    APIOfferFileSearchResultFromJSON,
    APIOfferFileSearchResultFromJSONTyped,
    APIOfferFileSearchResultToJSON,
} from './APIOfferFileSearchResult';
import type { APIPagination } from './APIPagination';
import {
    APIPaginationFromJSON,
    APIPaginationFromJSONTyped,
    APIPaginationToJSON,
} from './APIPagination';

/**
 * 
 * @export
 * @interface APIOfferFileSearchResponse
 */
export interface APIOfferFileSearchResponse {
    /**
     * 
     * @type {number}
     * @memberof APIOfferFileSearchResponse
     */
    total: number;
    /**
     * 
     * @type {number}
     * @memberof APIOfferFileSearchResponse
     */
    maxScore: number | null;
    /**
     * 
     * @type {Array<APIOfferFileSearchResult>}
     * @memberof APIOfferFileSearchResponse
     */
    results: Array<APIOfferFileSearchResult>;
    /**
     * 
     * @type {APIPagination}
     * @memberof APIOfferFileSearchResponse
     */
    page: APIPagination;
}

/**
 * Check if a given object implements the APIOfferFileSearchResponse interface.
 */
export function instanceOfAPIOfferFileSearchResponse(value: object): value is APIOfferFileSearchResponse {
    if (!('total' in value) || value['total'] === undefined) return false;
    if (!('maxScore' in value) || value['maxScore'] === undefined) return false;
    if (!('results' in value) || value['results'] === undefined) return false;
    if (!('page' in value) || value['page'] === undefined) return false;
    return true;
}

export function APIOfferFileSearchResponseFromJSON(json: any): APIOfferFileSearchResponse {
    return APIOfferFileSearchResponseFromJSONTyped(json, false);
}

export function APIOfferFileSearchResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): APIOfferFileSearchResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'total': json['total'],
        'maxScore': json['max_score'],
        'results': ((json['results'] as Array<any>).map(APIOfferFileSearchResultFromJSON)),
        'page': APIPaginationFromJSON(json['page']),
    };
}

export function APIOfferFileSearchResponseToJSON(value?: APIOfferFileSearchResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'total': value['total'],
        'max_score': value['maxScore'],
        'results': ((value['results'] as Array<any>).map(APIOfferFileSearchResultToJSON)),
        'page': APIPaginationToJSON(value['page']),
    };
}

